import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  TextField,
  MenuItem,
  Button,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Label from "../../../components/Label/Label";

const BatchFilterPopup = ({
  open,
  onClose,
  filterValues,
  onChange,
  onReset,
  onGenerate,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      sx={{ borderRadius: "16px !important", margin: 0 }}
      BackdropProps={{
        style: { backgroundColor: "transparent" },
      }}
      PaperProps={{
        sx: {
          borderRadius: 3,
          maxWidth: "276px",
          boxShadow: "none",
          bottom: 0,
          position: "fixed",
          left: 58,
          margin: 0,
          boxShadow: "none",
        },
      }}
    >
      <Box
        sx={{ backgroundColor: "#E8EDF4", minHeight: "calc(100vh - 170px)" }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            fontSize:14,
            fontWeight:600,
            paddingLeft:'10px',
            alignItems:'center'
          }}
        >
          Batch Filter
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "column",
            height: "100%",
            padding: "5px",
          }}
        >
          <DialogContent sx={{ padding: "0px", boxShadow: "none" ,minHeight: "calc(100vh - 280px)" , overflow:'auto'}}>
            <Box
              display="flex"
              flexDirection="column"
              gap={2}
              p={1}
              mb={1}
              sx={{
                backgroundColor: "#ffff",
                borderRadius: "8px",
                boxShadow: "none",
              }}
            >
              <Label text={"Batch Dates"}> </Label>
              <TextField
                label="From"
                type="date"
                size="small"
                value={filterValues.from_date || ""}
                onChange={(e) => onChange("from_date", e.target.value)}
                InputLabelProps={{ shrink: true }}
                fullWidth
              />
              <TextField
                label="To"
                type="date"
                size="small"
                value={filterValues.to_date || ""}
                onChange={(e) => onChange("to_date", e.target.value)}
                InputLabelProps={{ shrink: true }}
                fullWidth
              />
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              gap={2}
              p={1}
              mb={1}
              sx={{ backgroundColor: "#ffff", borderRadius: "8px" }}
            >
              <Label text={"Status"}> </Label>
              <TextField
                select
                label="Status"
                size="small"
                fullWidth
                value={filterValues.status}
                onChange={(e) => onChange("status", e.target.value)}
              >
                <MenuItem value="">Select</MenuItem>
                <MenuItem value="Approved">Approved</MenuItem>
                <MenuItem value="Draft">Draft</MenuItem>
                {/* <MenuItem value="Invalid">Invalid</MenuItem> */}
              </TextField>
            </Box>
            {/* <Box
            display="flex"
            flexDirection="column"
            gap={2}
            p={2}
            mb={2}
            sx={{ backgroundColor: "#ffff", borderRadius: "8px" }}
          >
            <Label text={"Unit Operations"}> </Label>
            <TextField
              select
              label="Batch Values Status"
              size="small"
              fullWidth
              value={filterValues.batchValuesStatus || "All"}
              onChange={(e) => onChange("batchValuesStatus", e.target.value)}
            >
              <MenuItem value="All">All</MenuItem>
              <MenuItem value="Valid">Valid</MenuItem>
              <MenuItem value="Invalid">Invalid</MenuItem>
            </TextField>
          </Box> */}
          </DialogContent>
          <Box
            display="flex"
            justifyContent="end"
            gap={1}
            p={1}
            sx={{ backgroundColor: "#ffff", borderRadius: "8px" }}
          >
            <Button variant="outlined" onClick={onReset}>
              Reset
            </Button>
            <Button variant="contained" onClick={onGenerate}>
              Submit
            </Button>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default BatchFilterPopup;
